import { useState, useEffect, useCallback } from "react";
import { getAllUsers } from "../../axios/axiosFunctions";
import { DataGrid } from '@mui/x-data-grid';
import { Typography, Button, Dialog, DialogTitle, DialogContent, Box } from "@mui/material";
import { PersonAdd } from "@mui/icons-material";
import { getHomeColumns } from "../../utils/homeCols";
import CreateUser from "../../components/forms/CreateUser";
import ShowReviewersDialog from "../../components/dialogs/ShowReviewersDialog";
import SelfReportDialog from "../../components/dialogs/SelfReportDialog";
import { useIsMobile } from "../../utils/useIsMobile";

const Home = () => {

  const isMobile = useIsMobile();
  const [rows, setRows] = useState([{id:1}]);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [openReviewersDialog, setOpenReviewersDialog] = useState(false);
  const [reportUser, setReportUser] = useState(null);
  const [openReportDialog, setOpenReportDialog] = useState(false);

  const fetchUsers = async()=>{
    const users = await getAllUsers();
    if(users){
      const tempRows = users.map((u)=>({
        id: u._id,
        firstName: u.firstName,
        lastName: u.lastName,
        email: u.email,
        has360: u.has360 || false,
        source: u.source || 'manual',
      }));
      setRows(tempRows);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleUserCreated = () => {
    fetchUsers();
    setTimeout(() => {
      setOpenCreateDialog(false);
    }, 2000);
  };

  const handleShowReviewers = useCallback((userId) => {
    setSelectedUserId(userId);
    setOpenReviewersDialog(true);
  }, []);

  const handleViewReport = useCallback((row) => {
    setReportUser(row);
    setOpenReportDialog(true);
  }, []);

  const homeColumns = getHomeColumns(handleShowReviewers, handleViewReport);

  return (
    <>
      <Box sx={{display:"flex", flexDirection: { xs: "column", sm: "row" }, justifyContent:"space-between", alignItems: { xs: "stretch", sm: "center" }, gap: { xs: 2, sm: 0 }, marginBottom:{ xs: "30px", md: "50px" }}}>
        <Typography variant="h3" fontWeight={500} color="secondary" sx={{ fontSize: { xs: "1.5rem", sm: "2rem", md: "3rem" } }}>Users</Typography>
        <Button
          variant="contained"
          startIcon={<PersonAdd/>}
          onClick={() => setOpenCreateDialog(true)}
        >
          Create User
        </Button>
      </Box>
      <Box sx={{ overflowX: "auto" }}>
        <DataGrid columns={homeColumns} rows={rows} showToolbar/>
      </Box>

      <Dialog fullScreen={isMobile} open={openCreateDialog} onClose={() => setOpenCreateDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Create User</DialogTitle>
        <DialogContent>
          <CreateUser onUserCreated={handleUserCreated}/>
        </DialogContent>
      </Dialog>

      <ShowReviewersDialog
        open={openReviewersDialog}
        onClose={() => setOpenReviewersDialog(false)}
        userId={selectedUserId}
        onUpdate={fetchUsers}
      />

      <SelfReportDialog
        open={openReportDialog}
        onClose={() => setOpenReportDialog(false)}
        user={reportUser}
      />
    </>
  )
}

export default Home
